module.exports = __webpack_public_path__ + "assets/a3d66d0cbd8a1b18a9e156f066b6a746.svg";